/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

/*COMPONENT*/
import BlogListPublic from "../../Components/public/BlogListPublic";
import Carousel from "../../Components/public/Carousel";

/*REDUX*/
import {
  getBlogListPublic,
  getBlogListPopular,
  search_blog,
} from "../../App/actions/blogAction";
import { getBanner } from "../../App/actions/authActions";
import { activities_timeseries } from "../../App/actions/activities";

/*PICTURE*/
import icon_search from "../../Assets/svg/icon_search.svg";

/*FUNCTION*/
import history from "../../App/actions/history";
import dict from "../../Data/dict.json";

/*DATA*/
import domain_list from "../../Data/domain_list";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

const DashboardPublic = ({
  activities_timeseries,
  auth,
  getBlogListPublic,
  getBlogListPopular,
  getBanner,
  search_blog,
  match,
  blog,
  blogs,
}) => {
  const [search_params, set_search_params] = useState("");
  const [search_params_final, set_search_params_final] = useState("");
  const [modal_search, set_modal_search] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    activities_timeseries("view");
    const { domain } = auth;
    const function_list = [
      getBlogListPublic(window.location.hostname),
      getBlogListPopular(),
      getBanner(),
    ];
    let array = function_list;
    const delay_c = 0;
    const delay = () => new Promise((res) => setTimeout(res, delay_c));
    const parent_function = () => {
      return array.reduce(
        (last_promise, object) =>
          last_promise.then((result_sum) =>
            child_function(object).then((result_current) => [
              ...result_sum,
              result_current,
            ]),
          ),
        Promise.resolve([]),
      );
    };
    const child_function = async (object) => {
      return delay().then(() => {
        return object;
      });
    };
    parent_function().then(() => {});

    const premium_status = domain_list?.[domain]?.status;
    if (premium_status === "premium") {
      history.push("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const triggerChange = (value) => {
    search_blog(value);
    set_search_params_final(value);

    // const { search_params } = this.state;
    // this.setState({ search_params_final: search_params });
  };

  const handleChange = (e) => {
    set_modal_search(true);
    const value = e.target.value;
    set_search_params(value);

    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      triggerChange(value);
    }, WAIT_INTERVAL);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY) {
      const value = e.target.value;
      triggerChange(value);
    }
  };

  const handleOnMouseDown = (e) => {
    e.preventDefault();
  };

  const toggleModal = () => {
    set_modal_search(true);
  };

  const closeSearch = () => {
    set_modal_search(false);
  };

  // let { tag_list } = this.props.play;
  const language = localStorage?.language || "ina";
  const mode = match?.params?.mode ? match?.params?.mode : "";

  // const { geo_project_list_public } = this.props.project;
  const { blog_list } = blog;
  let blog_list_filtered = blog_list;
  // let blog_list_result = [];

  if (mode === "publication_free") {
    blog_list_filtered = blog_list.filter((blog) =>
      ["public", "free"].includes(blog?.market_status.status),
    );
  } else if (mode === "publication_paid") {
    blog_list_filtered = blog_list.filter((blog) =>
      ["paid"].includes(blog?.market_status.status),
    );
  } else {
    blog_list_filtered = blog_list;
  }
  let item_content = (
    <main>
      <BlogListPublic blog_list={blog_list_filtered} />
      {/* <ProjectListPublic geo_project_list_public={geo_project_list_public} /> */}
    </main>
  );
  if (["publication_free", "publication_paid"].includes(mode)) {
    item_content = (
      <main>
        <BlogListPublic blog_list={blog_list_filtered} />
      </main>
    );
  } else {
    item_content = (
      <main>
        <BlogListPublic blog_list={blog_list_filtered} />
      </main>
    );
  }
  let result_search_content;

  const result_search_blog = (
    <main>
      {blogs.length > 0 ? (
        <main>
          {blogs.map((blog) => {
            const { _id, title, title_en, link } = blog;
            return (
              <Link to={`/blog_read/${link}`} key={_id}>
                <div
                  className="container_notification"
                  onMouseDown={handleOnMouseDown}
                  data-mapid="clickPilihanPublikasi"
                >
                  {language === "ina" ? title : title_en || title}
                </div>
              </Link>
            );
          })}
        </main>
      ) : !search_params_final ? (
        <div />
      ) : (
        <div className="container_notification">
          {dict["Publication not found"][language]}
        </div>
      )}
    </main>
  );
  let placeholder = dict["Search all publication"][language];
  if (mode === "publication_free") {
    placeholder = dict["Search free publication"][language];
    result_search_content = <div>{result_search_blog}</div>;
  } else if (mode === "publication_paid") {
    placeholder = dict["Search data exchange"][language];
    result_search_content = <div>{result_search_blog}</div>;
  }
  // else if (mode === "publication_project") {
  //   placeholder = dict["Search public project"][language];
  //   result_search_content = <div>{result_search_project}</div>;
  // }
  else {
    placeholder = dict["Search all publication"][language];
    result_search_content = (
      <div>
        {result_search_blog}
        {/* {result_search_project} */}
      </div>
    );
  }
  const search_content = (
    <div
      className="input_rounded"
      style={{
        position: "absolute",
        width: "500px",
        maxWidth: "50vw",
        margin: "auto",
        zIndex: "2",
      }}
    >
      <div className="icon-text">
        <div>
          <img
            src={icon_search}
            alt="search"
            height="16px"
            style={{ marginBottom: "5px" }}
          />
        </div>
        <div>
          <input
            className="form-rounded"
            type="text"
            placeholder={placeholder}
            autoComplete="off"
            name="search_params"
            value={search_params}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onFocus={toggleModal}
            onBlur={closeSearch}
            data-mapid="inputPublikasi"
            style={{
              overflow: "hidden",
              boxSizing: "border-box",
              border: "none",
              backgroundColor: "transparent",
              fontSize: "15px",
              color: "#5e5e5e",
              textAlign: "left",
            }}
          />
        </div>
      </div>
      {modal_search && (
        <section
          style={{
            height: "600px",
            maxHeight: "60vh",
            overflowY: "auto",
            paddingBottom: "10px",
            zIndex: 99,
            backgroundColor: "#ffffff",
          }}
        >
          {result_search_content}
        </section>
      )}
    </div>
  );

  return (
    <main className="main_container">
      <section
        style={{
          textAlign: "center",
          zIndex: "2",
          width: "100%",
        }}
      >
        <Carousel />
        <div
          style={{
            paddingTop: "20px",
            paddingBottom: "60px",
            marginBottom: "-60px",
          }}
        ></div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "50px",
            marginTop: "10px",
          }}
        >
          {search_content}
        </div>
      </section>
      <section style={{ marginTop: "50px" }}>{item_content}</section>
      <Helmet>
        <title>
          {dict["Location Intelligence Platform Indonesia"][language]}
        </title>
        <meta
          name="description"
          content={dict["Location Intelligence Platform Indonesia"][language]}
        />
      </Helmet>
    </main>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    blog: state.blog,
    blogs: state.blog.blog_list_search,
  };
};

export default connect(mapStateToProps, {
  getBlogListPublic,
  getBlogListPopular,
  getBanner,
  search_blog,
  activities_timeseries,
})(DashboardPublic);
